import * as React from 'react'
import { LocationsButton } from '../LocationsButton'
import { BillToLocation } from '../../BillToLocation'
import { ServiceLocations } from '../../ServiceLocations'
import {
  useGetServiceLocationListPropHeaders,
  getPopoverContentStyles,
} from '../../hooks'
import { MatchCreateNewButton } from '@user/components/Location'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import { LocationsPopoverContentProps } from '../../typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'
import {
  createLocationPermission,
  useCheckPermissions,
  LocationCreatePermOps,
} from '@user/store/authorization/permissions'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export const LocationsPopoverContent: React.FC<LocationsPopoverContentProps> = (
  props,
) => {
  const {
    billTo,
    buttonStyle,
    displayMatch,
    error,
    loading,
    serviceLocations,
    matched,
    updatePosition,
    isListView,
    field,
    listViewValue,
  } = props

  const { popHeader } = useGetServiceLocationListPropHeaders(
    field,
    listViewValue,
  )

  const [canCreateLocations] = useCheckPermissions(
    createLocationPermission as LocationCreatePermOps,
  )

  const entityData =
    props.variant === 'entity'
      ? {
          canUpdateEntity: props.canUpdateEntity,
          entityId: props.entityId,
          entityType: props.entityType,
          entityBranchId: props.entityBranchId,
        }
      : {
          canUpdateEntity: false,
          entityId: -1,
          entityType: ENTITY_TYPES.Opportunity,
          entityBranchId: '-1',
        }

  const styles = getPopoverContentStyles(useTheme())
  const isTidalEnabled = useTidalThemeActive()

  return (
    <Box p={1} pb={2} mt={isTidalEnabled ? 1.75 : 1.4}>
      <Box display="flex" alignItems="center">
        {props.buttonStyle === 'text' && (
          <LocationsButton
            {...props}
            listViewHeader={popHeader}
            variant={buttonStyle || 'text'}
          />
        )}
        {props.variant === 'entity' &&
          props.canUpdateEntity &&
          canCreateLocations &&
          displayMatch &&
          !isListView && (
            <Box ml="auto" mr={1}>
              <MatchCreateNewButton {...props} />
            </Box>
          )}
      </Box>
      {props.buttonStyle !== 'chip' && <hr style={styles.divider} />}
      <Box
        display="flex"
        minWidth={error ? 'unset' : 340}
        minHeight={
          error ? 'unset' : isListView && field !== 'address' ? 70 : 150
        }
      >
        {loading ? (
          <CircularProgress color="primary" sx={styles.spinner} />
        ) : error ? (
          <Box p={1} width="100%">
            <Alert severity="error">Unable to load Locations</Alert>
          </Box>
        ) : (
          <>
            {!isListView && (
              <BillToLocation
                {...entityData}
                {...props}
                billToLocation={billTo}
                onContentSizeChange={updatePosition}
                readonly={matched}
                includeHeader={true}
                variant="card"
              />
            )}

            <ServiceLocations
              {...entityData}
              {...props}
              serviceLocations={serviceLocations}
              onContentSizeChange={updatePosition}
              readonly={props.variant === 'selected'}
              variant="card"
            />
          </>
        )}
      </Box>
    </Box>
  )
}
LocationsPopoverContent.displayName = 'LocationsPopoverContent'
